import { cn } from '@zep/utils';
interface ServiceButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}
export const ServiceButton = ({
  label,
  isActive,
  onClick
}: ServiceButtonProps) => {
  return <button onClick={onClick} className={cn('w-[110px] tablet:w-[200px]', 'tablet:px-quiz-xl tablet:py-quiz-md', 'px-quiz-md py-quiz-sm', 'rounded-quiz-xl', 'flex items-center justify-center', 'transition-all duration-200', isActive ? 'bg-quiz-white shadow-[0px_8px_20px_0px_rgba(103,88,255,0.24)]' : 'bg-quiz-opacity-white-6 hover:bg-quiz-opacity-white-7')} data-sentry-component="ServiceButton" data-sentry-source-file="ServiceButton.tsx">
      <span className={cn('text-center whitespace-nowrap', isActive ? 'bg-gradient-to-l from-quiz-purple-400 to-quiz-blue-400 bg-clip-text text-transparent font-[800] text-[15px] tablet:text-[22px] tablet:font-[700]' : 'text-quiz-gray-600 font-[600] text-[12px] tablet:text-[15px] tablet:font-[700]')}>
        {label}
      </span>
    </button>;
};